import { createDiseaseDiagnosisText } from './portraitView'

export const marriageOptions = [
  { label: '未婚', value: 0 },
  { label: '已婚', value: 1 },
  { label: '丧偶', value: 2 },
  { label: '离异', value: 3 },
  { label: '其他', value: 4 }
]

export const complianceOptions = [
  { label: '待评估', value: 'PENDING' },
  { label: '依从性高', value: 'HIGH' },
  { label: '依从性中', value: 'MEDIUM' },
  { label: '依从性低', value: 'LOW' }
]

export const MAX_DIAGNOSE_TAGS = 2

const DIAGNOSIS_TAG_FIELD_NAMES = [
  'diagnosis_default_tags',
  'diagnosis_tags',
  'diagnosis_tag_list',
  'diagnosis_tags_all',
  'diagnosisTags',
  'diagnosisDefaultTags'
]

export function normalizeNumberValue(value) {
  if (value === '' || value === undefined || value === null) return ''
  const parsedValue = Number(value)
  return Number.isNaN(parsedValue) ? value : parsedValue
}

export function normalizeSelectValue(value) {
  return value === '' || value === undefined || value === null ? undefined : value
}

export function normalizeDictOptions(items) {
  if (!Array.isArray(items)) return []
  return items.map(item => ({
    label: item?.label || item?.value || '',
    value: item?.value || item?.label || ''
  }))
}

export function getDictOptions(dictSource, fieldName) {
  const dictList = typeof dictSource === 'function' ? dictSource() : dictSource
  if (!Array.isArray(dictList)) return []
  const target = dictList.find(item => item?.fieldName === fieldName)
  return normalizeDictOptions(target?.items)
}

export function normalizeDiagnosisTags(items) {
  if (!Array.isArray(items)) return []
  return items
    .map(item => {
      if (typeof item === 'string') return item.trim()
      if (item && typeof item === 'object') {
        const value = item.label || item.value || item.name
        return typeof value === 'string' ? value.trim() : ''
      }
      return ''
    })
    .filter(Boolean)
}

export function getDiagnosisDefaultTagsByDict(dictSource) {
  const dictList = typeof dictSource === 'function' ? dictSource() : dictSource
  if (!Array.isArray(dictList)) return []
  const target = dictList.find(item => DIAGNOSIS_TAG_FIELD_NAMES.includes(item?.fieldName))
  return normalizeDiagnosisTags(target?.items)
}

export function createPortraitForm() {
  return {
    basic: {
      name: '',
      gender: '',
      age: '',
      phone: '',
      idCard: '',
      job: '',
      marriage: undefined,
      compliance: undefined,
      complianceLabel: '',
      diagnosisDefaultTags: [],
      diagnosisTags: [],
      diagnosisManualTags: ''
    },
    summary: {
      stage: '',
      status: '',
      risk: '',
      todo: ''
    },
    portrait: {
      currentDiseaseStage: '',
      currentTouchStage: '',
      currentMedicinesText: '',
      medicationEndDateValue: '',
      diagnosis: '',
      emotion: undefined,
      responsePattern: undefined,
      contactPreference: undefined,
      cooperation: undefined
    }
  }
}

export function normalizeDiagnoseFields(basicForm) {
  if (!Array.isArray(basicForm.diagnosisTags)) {
    basicForm.diagnosisTags = []
  }
  if (basicForm.diagnosisTags.length > MAX_DIAGNOSE_TAGS) {
    basicForm.diagnosisTags = basicForm.diagnosisTags.slice(0, MAX_DIAGNOSE_TAGS)
  }

  const hasRemark = Boolean((basicForm.diagnosisManualTags || '').trim())
  if (basicForm.diagnosisTags.length >= MAX_DIAGNOSE_TAGS) {
    basicForm.diagnosisManualTags = ''
    return
  }
  if (hasRemark && basicForm.diagnosisTags.length > 1) {
    basicForm.diagnosisTags = basicForm.diagnosisTags.slice(0, 1)
  }
}

export function syncPortraitForm(form, data = {}) {
  form.basic.name = data.nameDisplay || ''
  form.basic.gender = data.genderLabel || data.gender || ''
  form.basic.age = data.age || ''
  form.basic.phone = data.phone || ''
  form.basic.idCard = data.idCard || ''
  form.basic.job = data.occupation || data.occupationLabel || ''
  form.basic.marriage = normalizeSelectValue(normalizeNumberValue(data.maritalStatus))
  form.basic.compliance = normalizeSelectValue(data.currentStatusMedicationAdherenceValue)
  form.basic.complianceLabel = data.currentStatusMedicationAdherenceLabel || ''
  form.basic.diagnosisDefaultTags = normalizeDiagnosisTags(data.diagnosisDefaultTags)
  form.basic.diagnosisTags = Array.isArray(data.diagnosisTags) ? [...data.diagnosisTags] : []
  form.basic.diagnosisManualTags = data.diagnosisManualTags || ''
  normalizeDiagnoseFields(form.basic)

  form.summary.stage = data.followUpCountLabel || data.followUpCountValue || ''
  form.summary.status = data.currentStatus || ''
  form.summary.risk = data.keyRiskLabel || ''
  form.summary.todo = data.todoItems || ''

  form.portrait.followUpCountLabel = data.followUpCountLabel || data.followUpCountValue || ''
  form.portrait.currentCourseMedicationDaysLabel =
    data.currentCourseMedicationDaysLabel || data.currentCourseMedicationDaysValue || ''
  form.portrait.currentMedicinesText = Array.isArray(data.currentMedication)
    ? data.currentMedication.join('，')
    : ''
  form.portrait.medicationEndDateValue = data.medicationEndDateValue || ''
  form.portrait.diagnosis = createDiseaseDiagnosisText(data)
  form.portrait.emotion = normalizeSelectValue(data.emotionStateValue)
  form.portrait.responsePattern = normalizeSelectValue(data.responsePatternValue)
  form.portrait.contactPreference = normalizeSelectValue(data.contactPreferenceValue)
  form.portrait.cooperation = normalizeSelectValue(data.communicationComplianceValue)
}

export function buildModifyPayload(form, initialData = {}) {
  const diagnosisTags = Array.isArray(form.basic.diagnosisTags) ? form.basic.diagnosisTags : []

  return {
    ucDoctorId: initialData.ucDoctorId,
    ucPatientId: initialData.ucPatientId,
    occupation: form.basic.job || undefined,
    maritalStatus:
      form.basic.marriage === '' ? undefined : normalizeNumberValue(form.basic.marriage),
    diagnosisTags: [...diagnosisTags],
    diagnosisManualTags: form.basic.diagnosisManualTags || undefined,
    keyRiskLabel: form.summary.risk || undefined,
    communicationComplianceValue: form.portrait.cooperation || undefined,
    contactPreferenceValue: form.portrait.contactPreference || undefined,
    responsePatternValue: form.portrait.responsePattern || undefined,
    emotionStateValue: form.portrait.emotion || undefined
  }
}
